import { render, staticRenderFns } from "./DismissOrgDialog.vue?vue&type=template&id=00da8272&scoped=true"
import script from "./DismissOrgDialog.vue?vue&type=script&lang=js"
export * from "./DismissOrgDialog.vue?vue&type=script&lang=js"
import style0 from "./DismissOrgDialog.vue?vue&type=style&index=0&id=00da8272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da8272",
  null
  
)

export default component.exports